/*
 * This function auto-imports routes from each `routes.js` file inside modules folder
 * */

export function autoImportRoutes() {
  const filePaths = require.context('../modules/', true, /routes.js/)

  return filePaths.keys().map(filePath => {
    const pageName = filePath.split('/')[1] // get module name from path eg ./module-name/routes.js
    return require(`@/modules/${pageName}/routes.js`).default
  })
}
